import React from 'react';
import { FormattedMessage } from 'react-intl';
import get from 'lodash/get';

export const Installer = ({ values }) => {
  const employess = get(values, 'employees', []) || [];
  return (
    <>
      <div className="row">
        {employess.map((employe, index) => (
          <div className="col-12 ViewOrEdit" key={index}>
            <div>
              <strong>
                <FormattedMessage id="Instalador" /> {index + 1}:
              </strong>
              <span>{get(employe, 'name', '-')}</span>
            </div>
            {employess.length - 1 !== index && <div className="kt-space-20" />}
          </div>
        ))}
      </div>
    </>
  );
};

export default Installer;
